import { render, staticRenderFns } from "./InvoiceBatchShippingCharges.vue?vue&type=template&id=5a2960c0&scoped=true"
import script from "./InvoiceBatchShippingCharges.vue?vue&type=script&lang=js"
export * from "./InvoiceBatchShippingCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2960c0",
  null
  
)

export default component.exports